/**
 * 호반건설 CI — 가로형 시그니처 (심볼 + HOBAN 워드마크).
 *
 * 출처: https://www.ihoban.co.kr/pr/ci/web 의 영문 CI PDF 에서 벡터를 추출했다.
 * 원본 PDF 는 CMYK 라 RGB 변환값이 사이트에 공표된 규격색과 어긋난다 —
 * 여기서는 **공표된 규격색**을 쓴다. 발주처 원본 에셋을 받으면 교체할 것.
 *
 * 세 가지로 그린다 —
 *   `color`   규격색 그대로. 밝은 면에만 쓴다.
 *   `reverse` 심볼은 규격색, 워드마크만 currentColor. **어두운 면용**이다 —
 *             워드마크 규격색이 진회색(#575553)이라 어두운 배경에서는 묻힌다.
 */
const SPEC_COLOR = {
  ORANGE: "#ee7500",
  GRAY: "#898989",
  DARK: "#575553",
} as const;

const PATHS = [
  {
    role: "DARK",
    m: "1 0 0 1 442.822 387.738",
    d: "M0 0C-0.666 -2.515 -1.654 -4.715 -2.936 -6.541C-4.205 -8.349 -5.793 -9.778 -7.658 -10.791C-9.516 -11.801 -11.684 -12.314 -14.102 -12.314C-16.584 -12.314 -18.789 -11.801 -20.658 -10.791C-22.529 -9.778 -24.119 -8.349 -25.377 -6.542C-26.648 -4.718 -27.619 -2.517 -28.266 -0.002C-28.918 2.529 -29.248 5.337 -29.248 8.349C-29.248 11.316 -28.918 14.07 -28.266 16.539C-27.619 18.989 -26.65 21.13 -25.383 22.9C-24.123 24.655 -22.535 26.037 -20.664 27.008C-18.795 27.98 -16.584 28.473 -14.102 28.473C-11.68 28.473 -9.512 27.98 -7.65 27.01C-5.787 26.037 -4.199 24.653 -2.932 22.898C-1.652 21.128 -0.666 18.987 0 16.535C0.672 14.063 1.014 11.311 1.014 8.349C1.014 5.345 0.672 2.536 0 0M7.416 20.158C6.363 21.878 5.064 23.466 3.559 24.875C2.053 26.282 0.365 27.508 -1.457 28.516C-3.281 29.524 -5.285 30.314 -7.41 30.862C-11.666 31.958 -16.533 31.958 -20.791 30.862C-22.922 30.314 -24.926 29.524 -26.746 28.516C-28.572 27.506 -30.26 26.282 -31.76 24.875C-33.268 23.468 -34.566 21.878 -35.621 20.158C-36.676 18.435 -37.504 16.558 -38.084 14.582C-38.666 12.599 -38.961 10.501 -38.961 8.349C-38.961 6.152 -38.666 4.015 -38.084 1.993C-37.504 -0.027 -36.678 -1.945 -35.623 -3.708C-34.568 -5.472 -33.271 -7.102 -31.766 -8.552C-30.266 -10 -28.578 -11.26 -26.748 -12.291C-24.93 -13.322 -22.926 -14.134 -20.795 -14.704C-18.666 -15.271 -16.414 -15.56 -14.102 -15.56C-11.789 -15.56 -9.535 -15.271 -7.406 -14.704C-5.279 -14.134 -3.277 -13.322 -1.455 -12.291C0.371 -11.26 2.061 -10.003 3.564 -8.552C5.068 -7.102 6.365 -5.472 7.42 -3.708C8.475 -1.943 9.305 -0.019 9.883 2.01C10.465 4.042 10.758 6.175 10.758 8.349C10.758 10.501 10.463 12.599 9.881 14.582C9.305 16.556 8.475 18.43 7.416 20.158",
  },
  {
    role: "DARK",
    m: "1 0 0 1 388.609 398.265",
    d: "M0 0L-21.164 0L-21.164 20.128L-29.609 20.128L-29.609 -25.058L-21.164 -25.058L-21.164 -3.88L0 -3.88L0 -25.058L8.445 -25.058L8.445 20.128L0 20.128Z",
  },
  {
    role: "DARK",
    m: "1 0 0 1 487.182 382.198",
    d: "M0 0C-0.455 -0.96 -1.174 -1.795 -2.133 -2.479C-3.109 -3.179 -4.377 -3.732 -5.895 -4.127C-7.43 -4.528 -9.273 -4.73 -11.375 -4.73L-18.883 -4.73L-18.883 12.565L-11.598 12.565C-9.291 12.565 -7.326 12.316 -5.758 11.828C-4.209 11.346 -2.938 10.681 -1.979 9.851C-1.035 9.036 -0.348 8.058 0.061 6.939C0.482 5.798 0.697 4.547 0.697 3.219C0.697 2.057 0.463 0.975 0 0M-18.883 32.22L-13.277 32.22C-11.111 32.22 -9.234 32.022 -7.697 31.634C-6.184 31.249 -4.922 30.696 -3.941 29.986C-2.984 29.293 -2.271 28.45 -1.824 27.479C-1.373 26.494 -1.143 25.382 -1.143 24.175C-1.143 23.042 -1.338 21.986 -1.723 21.039C-2.105 20.097 -2.672 19.268 -3.406 18.571C-4.146 17.873 -5.072 17.318 -6.162 16.923C-7.262 16.523 -8.535 16.321 -9.947 16.321L-18.883 16.321ZM6.795 11.089C5.859 12.059 4.709 12.869 3.379 13.497C2.43 13.943 1.396 14.298 0.295 14.561C1.371 15.115 2.309 15.674 3.09 16.225C4.164 16.984 5.037 17.798 5.678 18.651C6.328 19.515 6.795 20.465 7.064 21.475C7.326 22.46 7.461 23.593 7.461 24.84C7.461 26.532 7.043 28.103 6.217 29.508C5.398 30.9 4.242 32.108 2.783 33.095C1.338 34.074 -0.416 34.845 -2.43 35.387C-4.428 35.923 -6.652 36.195 -9.029 36.195L-27.328 36.195L-27.328 -8.991L-6.207 -8.991C-3.816 -8.991 -1.617 -8.673 0.32 -8.047C2.273 -7.419 3.967 -6.536 5.352 -5.422C6.746 -4.302 7.838 -2.964 8.596 -1.449C9.357 0.073 9.742 1.731 9.742 3.475C9.742 5.015 9.486 6.439 8.979 7.706C8.469 8.976 7.736 10.115 6.795 11.089",
  },
  {
    role: "DARK",
    m: "1 0 0 1 512.113 391.827",
    d: "M0 0L7.426 15.737L14.652 0ZM7.674 26.566L-13.604 -18.62L-8.758 -18.62L-1.783 -3.88L16.488 -3.88L23.24 -18.62L31.916 -18.62L11.113 26.566Z",
  },
  {
    role: "DARK",
    m: "1 0 0 1 581.799 418.393",
    d: "M0 0L0 -31.76L-28.484 0L-33.381 0L-33.381 -45.186L-29.023 -45.186L-29.023 -10.88L0.92 -45.186L4.293 -45.186L4.293 0Z",
  },
  {
    role: "ORANGE",
    m: "1 0 0 1 333.752 400.76",
    d: "M0 0C0 -1.958 -1.586 -3.542 -3.543 -3.542L-74.41 -3.542C-76.368 -3.542 -77.954 -1.958 -77.954 0L-77.954 19.841C-77.954 21.799 -76.368 23.387 -74.41 23.387L-3.543 23.387C-1.586 23.387 0 21.799 0 19.841Z",
  },
  {
    role: "GRAY",
    m: "1 0 0 1 333.752 370.996",
    d: "M0 0C0 -1.958 -1.586 -3.542 -3.543 -3.542L-74.41 -3.542C-76.368 -3.542 -77.954 -1.958 -77.954 0L-77.954 19.842C-77.954 21.8 -76.368 23.387 -74.41 23.387L-3.543 23.387C-1.586 23.387 0 21.8 0 19.842Z",
  },
] as const;

interface HobanLogoProps {
  className?: string;
  /** 기본 `color`(밝은 면). 어두운 면에는 `reverse`. */
  variant?: "color" | "reverse";
}

/** `reverse` 는 워드마크만 currentColor 로 — 규격색(진회색)이 어두운 면에서 묻힌다 */
function fillFor(role: (typeof PATHS)[number]["role"], variant: HobanLogoProps["variant"]) {
  return variant === "reverse" && role === "DARK" ? "currentColor" : SPEC_COLOR[role];
}

export function HobanLogo({ className = "", variant = "color" }: HobanLogoProps) {
  return (
    <svg
      viewBox="255.793 171.126 330.288 56.692"
      role="img"
      aria-label="호반건설"
      className={`h-5 w-auto ${className}`}
    >
      {/* PDF 좌표계가 아래에서 위로 자라므로 뒤집는다 */}
      <g transform="matrix(1 0 0 -1 0 595.276)">
        {PATHS.map((p, i) => (
          <path key={i} fill={fillFor(p.role, variant)} transform={`matrix(${p.m})`} d={p.d} />
        ))}
      </g>
    </svg>
  );
}
